import { z } from 'zod';
import { baseFloorSchema } from './IBaseFloor';

// Schemas (source of truth)
export const floorSchema = baseFloorSchema.extend({
	shortFloorNick: z.string(),
	projectId: z.string(),
	buildingId: z.string().optional(),
	isHoist: z.boolean().optional(),
	isSpecialFloor: z.boolean().optional(),
	isMoving: z.boolean().optional(),
	isGroundFloor: z.boolean().optional(),
});

// Types (derived from schemas)
export type IFloor = z.infer<typeof floorSchema>;
